import React from 'react';
import { useTranslation } from 'react-i18next';
import format from 'date-fns/format';
import isToday from 'date-fns/isToday';
import isYesterday from 'date-fns/isYesterday';

import styles from './styles.module.scss';

const DateSeparator = ({ date }) => {
    const { t } = useTranslation();
    const messageDate = new Date(date);

    const getDateLabel = () => {
        if (isToday(messageDate)) {
            return t('today');
        }
        if (isYesterday(messageDate)) {
            return t('yesterday');
        }
        return format(messageDate, 'dd.MM.yyyy');
    };

    return (
        <div className={styles.dateSeparator}>
            <span className={styles.dateSeparator__text}>{getDateLabel()}</span>
        </div>
    );
};

export default DateSeparator;
